/**
 * Nguồn dữ liệu dự toán tùy chỉnh báo cáo
 * dmha 12.11.2024
 */
export default {
  Audit: 0, // kiểm tra
  Estimate:1, // lập dự toán
  Submit: 2, // lần nộp
};

